/**
 * 配色常量（与界面设计 token 一致的深色科技主题）。
 * 值取自 index.css 的 oklch 设计变量；canvas fillStyle 在现代浏览器支持 oklch。
 */
export const THEME = {
  bg: 'oklch(0.105 0.008 240)',
  panel: 'oklch(0.12 0.008 238)',
  shaft: 'oklch(0.145 0.008 235)',
  grid: 'oklch(1 0 0 / 8%)',
  border: 'oklch(1 0 0 / 12%)',
  text: 'oklch(0.90 0.006 220)',
  textDim: 'oklch(0.52 0.008 225)',
  car: 'oklch(0.72 0.165 196)', // primary 青色
  carFull: 'oklch(0.62 0.22 25)', // destructive 红
  door: 'oklch(0.75 0.155 65)', // accent 琥珀
  up: 'oklch(0.72 0.165 196)', // 上行 = 青色
  down: 'oklch(0.75 0.155 65)', // 下行 = 琥珀
  waitWarn: 'oklch(0.62 0.22 25)', // 超时告警 = 红
  chart1: 'oklch(0.72 0.165 196)',
  chart2: 'oklch(0.75 0.155 65)',
  chart3: 'oklch(0.68 0.17 158)',
  chart4: 'oklch(0.68 0.165 320)',
  chart5: 'oklch(0.62 0.22 25)',
} as const;

/** 兼容旧引用（shaft-renderer 内部别名）。 */
export const PALETTE = THEME;
